var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"dom",staticClass:"charts chart-bar",staticStyle:{"width":"90%","height":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }